import { react2angular } from 'react2angular';
import DateFilter from './DateFilter';

angular
  .module('analysis.module')
  .component('dateFilter', react2angular(DateFilter, [
    'startDate',
    'endDate',
    'mode',
    'value',
    'units',
    'defaultWindowHours',
    'onStartDateChange',
    'onEndDateChange',
    'onModeChange',
    'onValueChange',
    'onReset',
    'onInitializeRange',
  ]));
